import styled from "styled-components";
import React, { ReactElement, FC, useMemo, ReactNode} from "react";


//todo bordo

export interface buttonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  text?: string;
  icon?: string | ReactNode;
  uppercase?: boolean;
  border?: boolean;
  fontWeight?: string;
  borderColor?: string;
  background: string;
  removePadding?: boolean;
  removeHover?: boolean;
  padding?: string
  iconRight?: boolean;
  removeRotate?: boolean
  className?: string

}

const StyledButton = styled.button<buttonProps>`
  max-width:300px;
  background-color: ${(p) => p.background};
  color: ${(p) => p.color};
  padding: ${p => p.padding && !p.removePadding ? 'p.padding' : p.removePadding ? '0' : '18px 36px'};
  border: ${(p) =>
    p.borderColor
      ? `1px solid ${p.borderColor}`
      : "1px solid var(--black)"};
  font-size: 16px;
  font-weight: ${(p) => (p.fontWeight ? p.fontWeight : "bold")};
  line-height: 18px;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  opacity: ${(p) => (p.disabled ? "0.2" : "1")};
  transition: background-color 0.4s, border 0.4s;
  ${(p) =>
    !p.removeHover &&
    `&:hover {
      background-color: ${p.primary ? "var(--black)" : "var(--primary)"};
      color: var(--white);
      transition: background-color 0.4s , border 0.4s;
      border: ${p.primary ? " 1px solid var(--black)" : "1px solid var(--primary)"};
  }`}
`;

const Button: FC<buttonProps> = ({ className, removeRotate, iconRight, icon, primary, text, uppercase, ...props }): ReactElement => {

  const showIcon = useMemo(() => {

    if (typeof icon === "string") {
      if (iconRight) {
        return (
          <img src={icon} style={{ height: "12px", paddingRight: "6px" }} alt="" />
        );

      }
      else {
        return (
          <img src={icon} style={{ height: "12px", paddingLeft: "6px", transform: removeRotate ? "rotate(0deg)" : 'rotate(180deg)', }} alt="logo" />
        );
      }
    }
    else {
      return icon;
    }
  }, [icon, iconRight, removeRotate]);



  return (
    <StyledButton className={className} icon iconRight primary={primary} text={text} {...props}>
      <div className="d-flex justify-content-center align-items-center">
        <>
          {!iconRight && icon && showIcon}
          <div
          className=""
            style={
              uppercase
                ? { textTransform: "uppercase" }
                : { textTransform: "capitalize" }
            }
          >
            <span className=" h-100">{text && text}</span>
          </div>
          {iconRight && icon && showIcon}
        </>
      </div>
    </StyledButton>
  );
};

export { Button };
